import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { BodyPrimary, H4 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import * as React from 'react';
import styled, { css } from 'styled-components';

import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryLotNumber,
    getItemSummaryTitle,
    getItemSummaryUrl,
} from '@/redux/modules/item/summary/itemSummary.selectors';

type Props = {
    hideLotNumbers?: boolean;
    itemId: number;
    openOnBlank?: boolean;
};

const TitleRow = (props: Props) => {
    const { hideLotNumbers, itemId, openOnBlank } = props;
    const title = useAppSelector((state) => getItemSummaryTitle(state, itemId));
    const lotNumber = useAppSelector((state) => getItemSummaryLotNumber(state, itemId));
    const itemUrl = useAppSelector((state) => getItemSummaryUrl(state, itemId));

    const lotNumberDisplay = lotNumber ? (
        <BodyPrimary>
            {lotNumber}
            :&nbsp;{' '}
        </BodyPrimary>
    ) : (
        <BodyPrimary> &nbsp; 0000</BodyPrimary>
    );

    const targetProps = openOnBlank ? { rel: '', route: false, target: '_blank' } : { rel: '', route: true };

    return (
        <ContainerDiv>
            {title ? (
                <ItemTitleText as="span">
                    <Link
                        {...targetProps}
                        className="line-clamp-2"
                        data-testid="itemTitleText"
                        primary
                        to={itemUrl}
                    >
                        {!hideLotNumbers && lotNumberDisplay}
                        {title}
                    </Link>
                </ItemTitleText>
            ) : (
                <ItemTitleText as="span">Lorem ipsum dolor sit amet, consectetur adipiscing elit</ItemTitleText>
            )}
        </ContainerDiv>
    );
};

export default React.memo<Props>(TitleRow);

const ContainerDiv = styled.div`
    position: relative;
    display: block;
    margin-bottom: 2px;
    color: ${({ theme }) => theme.colors.black};
    min-height: 48px;
    overflow: visible;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobileWidth}) {
        min-height: 40px;
    }
`;

const ItemTitleStyles = css`
    display: inline-block;
    word-break: break-word;
    font-family: ${({ theme }) => theme.typography.fontSecondary};
    text-transform: capitalize;
    letter-spacing: 0.5px;
    white-space: normal;
    position: static;
    span:first-of-type {
        font-family: ${({ theme }) => theme.typography.fontSecondary};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobileWidth}) {
        font-size: 13px;
        line-height: 18px;
    }
`;

const ItemTitleText = styled(H4)`
    ${ItemTitleStyles}
`;
